<div class="img-wrap">
	<div class="header">
		<h2 class="left" *ngIf="data.title">
			{{ data.title }}
		</h2>

		<div class="header-actions">
			<button mat-icon-button (click)="copyUrl()" matTooltip="Copy URL" i18n-matTooltip>
				<mat-icon>content_copy</mat-icon>
			</button>
			<button mat-icon-button (click)="downloadImage()" matTooltip="Download" i18n-matTooltip [disabled]="isDownloading">
				<mat-icon *ngIf="!isDownloading">download</mat-icon>
				<mat-spinner *ngIf="isDownloading" diameter="20"></mat-spinner>
			</button>
			<button mat-icon-button [mat-dialog-close]="null" matTooltip="Close" i18n-matTooltip>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>

	<div class="image-container">
		<div class="loading-container" *ngIf="isLoading">
			<mat-spinner diameter="40"></mat-spinner>
		</div>
		<img
			[src]="data.assetPath | cloudinaryImageTransform : { width: 1080, mode: 'limit' }"
			[hidden]="isLoading"
			(load)="onImageLoad()"
			(click)="$event.stopPropagation()"
		/>
	</div>
</div>
